import { useQuery } from '@tanstack/react-query';

import ZoomRepository from '@/repositories/members/ZoomRepository';

import { ZoomRole } from '../types';

export const useZoomToken = (meetingNumber?: string, role: ZoomRole = ZoomRole.ATTENDEE) => {
  const repository = ZoomRepository();
  return useQuery({
    queryKey: ['zoomToken', meetingNumber, role],
    queryFn: () => repository.getZoomToken(meetingNumber, role),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled: !!meetingNumber
  });
};
